import ConfirmDialog from '../../components/common/ConfirmDialog';
import infoIcon from '../../assets/confirmation-info.svg';
import type { UserStatus } from '../../api/users';

interface Props {
  userName: string;
  status: UserStatus;
  isPending: boolean;
  errorMessage: string | null;
  onConfirm: () => void | Promise<void>;
  onCancel: () => void;
  returnFocus?: () => void;
}

/** User-specific wording and Figma presentation shared by the table and profile. */
export default function UserStatusDialog({ userName, status, isPending, errorMessage, onConfirm, onCancel, returnFocus }: Props) {
  const deactivating = status === 'blocked';
  const verb = deactivating ? 'Deactivate' : 'Activate';
  return <ConfirmDialog open appearance="centered" variant={deactivating ? 'danger' : 'default'}
    title={`${verb} User: ${userName}?`}
    message={deactivating
      ? 'Deactivating this user blocks access to the platform until reactivated.'
      : 'Activating this user restores access to the platform.'}
    secondaryMessage={deactivating ? 'You can reactivate at any time.' : undefined}
    icon={deactivating ? undefined : <img src={infoIcon} width="24" height="27.4286" alt="" />}
    closeLabel={deactivating ? 'Close' : undefined}
    dialogClassName="sm:px-[46px]"
    messageClassName={deactivating ? undefined : 'sm:!w-[596px] sm:min-h-[59px]'}
    confirmLabel={isPending ? `${verb === 'Deactivate' ? 'Deactivating' : 'Activating'}…` : `${verb} User`}
    isPending={isPending} errorMessage={errorMessage} onConfirm={onConfirm} onCancel={onCancel} returnFocus={returnFocus} />;
}
